module.exports = __webpack_public_path__ + "img/SCADA CH Line B.46966440.jpg";